import { render, staticRenderFns } from "./User-addresses-card.vue?vue&type=template&id=d4d0c4d0&scoped=true&"
import script from "./User-addresses-card.vue?vue&type=script&lang=js&"
export * from "./User-addresses-card.vue?vue&type=script&lang=js&"
import style0 from "./User-addresses-card.vue?vue&type=style&index=0&id=d4d0c4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d0c4d0",
  null
  
)

export default component.exports